/* V4O — regalos incluidos en cada pedido · v2 · 26/10/2026
   Garantiza que el carrito lleve SIEMPRE los 3 regalos (bolsas de envío, regalo
   sorpresa, guía de reventa) cuando hay al menos un producto normal, y que no
   queden regalos sueltos si el cliente vacía el carrito. Cubre los casos en que
   el formulario del tema no los añade (botón de pago exprés, widgets de apps,
   carrito editado a mano). Nunca duplica: añade solo los que falten y deja cada
   regalo en cantidad 1.
   v3 · Pack Invierno: por cada unidad del producto "Pack Invierno" (handle pack-invierno,
   20 variantes mix × lote) añade una "Prenda premium de regalo"; sin pack, la quita.
   La prenda premium cuenta como regalo, nunca como producto principal.
   Se identifica por product_id (inmutable aunque cambie el handle). */
(function () {
  'use strict';
  var GIFT_IDS = (window.V4O_GIFT_IDS || [63329983267165, 58859857838429, 63331271377245]).map(Number);
  var MARK = 'x-v4o-regalos';
  var busy = false, pending = false, timer = null, current = null;

  var PACK_PRODUCT_ID = 16666496074077; // producto "Pack Invierno" (pack-invierno)
  var PREMIUM_ID = 66325050753373; // pack-invierno-prenda-premium-regalo

  // Productos que no se envían (servicios): no llevan regalos, o el checkout pediría envío.
  var NO_GIFT_HANDLES = ['video-handpicking', 'handpicking-presencial'];

  function vid(item) { return Number(item.variant_id); }
  function isGift(item) { return GIFT_IDS.indexOf(vid(item)) !== -1 || vid(item) === PREMIUM_ID; }
  function needsGifts(item) { return !isGift(item) && NO_GIFT_HANDLES.indexOf(item.handle) === -1; }
  function packUnits(items) {
    return items.reduce(function (s, i) { return Number(i.product_id) === PACK_PRODUCT_ID ? s + i.quantity : s; }, 0);
  }

  function ownFetch(url, body) {
    var h = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    h[MARK] = '1';
    return window.fetch(url, { method: 'POST', headers: h, body: JSON.stringify(body) });
  }

  function refreshDrawer(resp) {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && resp && resp.sections) {
        drawer.renderContents(resp);
      }
    } catch (e) { /* el drawer se refresca solo en la siguiente apertura */ }
  }

  function reconcile() {
    if (busy) { pending = true; return current; }
    busy = true;
    var h = { 'Accept': 'application/json' }; h[MARK] = '1';
    current = window.fetch('/cart.js', { headers: h, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasMain = items.some(needsGifts);
        var present = {};
        var premiumLines = [];
        items.forEach(function (i) {
          if (GIFT_IDS.indexOf(vid(i)) !== -1) present[vid(i)] = i;
          else if (vid(i) === PREMIUM_ID) premiumLines.push(i);
        });
        var updates = {};
        var missing = [];
        if (hasMain) {
          GIFT_IDS.forEach(function (id) {
            if (!present[id]) missing.push({ id: id, quantity: 1 });
            else if (present[id].quantity !== 1) updates[present[id].key] = 1;
          });
        } else {
          Object.keys(present).forEach(function (id) { updates[present[id].key] = 0; });
        }
        // Prenda premium: una por cada Pack Invierno. Sin pack, fuera.
        var want = hasMain ? packUnits(items) : 0;
        if (want > 0 && !premiumLines.length) {
          missing.push({ id: PREMIUM_ID, quantity: want });
        } else {
          premiumLines.forEach(function (line, n) {
            var q = n === 0 ? want : 0;
            if (line.quantity !== q) updates[line.key] = q;
          });
        }
        var chain = Promise.resolve(null);
        if (Object.keys(updates).length) {
          chain = chain.then(function () {
            return ownFetch('/cart/update.js', { updates: updates, sections: 'cart-drawer,cart-icon-bubble' })
              .then(function (r) { return r.json(); }).then(function (resp) { refreshDrawer(resp); });
          });
        }
        if (missing.length) {
          chain = chain.then(function () {
            return ownFetch('/cart/add.js', { items: missing, sections: 'cart-drawer,cart-icon-bubble' })
              .then(function (r) { return r.json(); }).then(function (resp) { refreshDrawer(resp); });
          });
        }
        return chain;
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (pending) { pending = false; schedule(); }
      });
    return current;
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 350); }

  // Para quien necesite el carrito ya cuadrado antes de navegar (p. ej. la página del Pack Invierno).
  window.V4O_regalosSync = function () {
    clearTimeout(timer);
    var run = function () { pending = false; return reconcile(); };
    return busy && current ? current.then(run) : run();
  };

  // Intercepta cualquier cambio de carrito (tema, apps, pago exprés) salvo los propios.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && (init.headers[MARK] === '1' || (typeof init.headers.get === 'function' && init.headers.get(MARK) === '1'));
    var p = _fetch.apply(this, arguments);
    if (!own && CART_RE.test(url)) { p.then(schedule, function () {}); }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_RE.test(url)) {
      this.addEventListener('loadend', schedule);
    }
    return _open.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
